module.exports = __webpack_public_path__ + "img/2.ebc04bbd.png";